import React from "react";
import { Grid } from "material-ui";
import { Card } from "@material-ui/core";
import { CardHeader } from "material-ui";
import { CardContent } from "material-ui";
import { assets } from "../../assets";
import { HourlyDoughnutCardContent } from "./HourlyDoughnutCardContent";

export class HourlyDoughnutCard extends React.Component {

  render() {
    const { 
      classes, 
      chartName,
      t,
      i18n,
      loading,
      title,
      subTitle,
      barChartData
    } = this.props;

    return (
      <Grid item xs={12} sm={6}>
        <Card
          className={classes.card}
          style={{
            minHeight: 469
          }}
        >
          <CardHeader
            avatar={<img src={assets.icons.doughnutIcon} style={{ maxHeight: 20 }} alt=""/>}
            title={title}
            key={`${chartName}-card-header`}
            subheader={subTitle}
          />
          <CardContent
            key={`${chartName}-card-content`}
            style={{
              height: 300
            }}
          >
            <HourlyDoughnutCardContent  
              key={`${chartName}-card-content`} 
              chartName={chartName} 
              t={t} 
              classes={classes} 
              loading={loading}
              barChartData={barChartData}
              i18n={i18n}
            />
          </CardContent>
        </Card>
      </Grid>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ChartCards/HourlyDoughnutCard.js